import type { HeatingFuelMetrics } from '../../components/charts/HouseHeatingFuelSupabase';
import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import type { NarrativeTokenMap } from './narrativeTemplateEngine';

const CHART_ID = 'heating_fuel';

export type HeatingFuelViewId = 'main' | 'other' | 'fossil' | 'compare';

function viewIdFromChartMode(mode: HeatingFuelViewId): string {
  return mode;
}

export function buildHeatingFuelAuthoredBundle(
  locationName: string,
  metrics: HeatingFuelMetrics | null,
  chartMode: HeatingFuelViewId
) {
  if (!metrics) {
    return {
      overview: getAuthoredOverview(CHART_ID, viewIdFromChartMode(chartMode), ''),
      keyInsights: '',
      relevance: '',
      equity: '',
      authoringStatus: 'READY_SOURCE_VERIFY',
      usedAuthoredCopy: false,
    };
  }
  const changeSentence =
    metrics.elecShareChangePp != null
      ? ` Electric-heating share changed by ${metrics.elecShareChangePp > 0 ? '+' : ''}${metrics.elecShareChangePp.toFixed(1)} percentage points since ${metrics.baselineYear}.`
      : '';
  const tokens: Record<string, unknown> = {
    locationName,
    latestYear: metrics.latestYear,
    dominantFuel: metrics.topFuelType,
    dominantShare: Number(metrics.topFuelPercent.toFixed(1)),
    electricShare: Number(metrics.elecPercent.toFixed(1)),
    gasShare: Number(metrics.gasPercent.toFixed(1)),
    fossilShare: Number(metrics.fossilPercent.toFixed(1)),
    changeSentence,
    largestOtherFuel: metrics.secondFuelType,
    largestOtherShare: Number(metrics.secondFuelPercent.toFixed(1)),
    otherChangeSentence: '',
    priorYear: metrics.baselineYear,
    priorFossilShare: null,
    percentagePointChange: null,
    yearA: metrics.baselineYear,
    yearB: metrics.latestYear,
    electricPpChange: metrics.elecShareChangePp != null ? Number(metrics.elecShareChangePp.toFixed(1)) : null,
    gasPpChange: null,
    otherMajorShiftSentence: '',
  };
  return renderAuthoredNarrativeBundle(
    CHART_ID,
    viewIdFromChartMode(chartMode),
    tokens as NarrativeTokenMap
  );
}

export function heatingFuelOverviewDescription(chartMode: HeatingFuelViewId): string {
  return getAuthoredOverview(CHART_ID, viewIdFromChartMode(chartMode), 'ACS primary house-heating fuel shares.');
}
